import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import styles from './index.module.css';

const BackLink: Component<LinkProps> = ({ children, ...props }) => (
  <Link {...props} className={styles.link}>
    {children}
  </Link>
);

export default BackLink;
